module.exports = __webpack_public_path__ + "assets/img/home-download@2x.d23ab658.png";